import React, { Component } from 'react'
import { Row, Layout, Breadcrumb } from 'antd'
import { logout } from './auth';
import NavigationBar from './components/NavigationBar';

const { Header, Content, Footer } = Layout;

class Dashboard extends Component {
   
    handleLogout = (e) => {
        e.preventDefault()
        logout()
        .catch((error) => {
                // this.setState(setErrorMsg('Invalid username/password.'))
            })
    }
    

    render() {
        return(
            <Layout style={{ minHeight: '100vh' }}>
                <NavigationBar/>
                
                
                <Layout>
                    {/* <Header style={{ background: '#fff', padding: 0 }}>
                        
                    </Header> */}
                    
                    <Content style={{ margin: '0 16px' }}>
                        <h1>Visual Produce 7.6 Wholesaler Distributor Demo</h1>
                        
                        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                            <iframe width="960" height="540" src="https://www.youtube-nocookie.com/embed/Q2WuUzcR__Y?rel=0&amp;autoplay=1&controls=1&modestbranding=1&showinfo=0" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                        </div>
                    </Content>
                    {/* <Footer style={{ textAlign: 'center' }}>
                        Ant Design ©2016 Created by Ant UED
                    </Footer> */}
                </Layout>
                
                {/* <p>mediaaaalistsss</p>
                <button onClick={this.handleLogout}>log out</button>

                 */}

            </Layout>
        )
    }
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/Dashboard.js